import React, { useState } from 'react'
import styled from 'styled-components'

import { Helmet } from 'react-helmet'
import { NavLink as RouterNavLink, NavLinkProps } from 'react-router-dom'
import {
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Divider as MuiDivider,
  Grid,
  Link,
  Typography,
} from '@material-ui/core'
import { spacing } from '@material-ui/system'
import { CloudDownload as MuiCloudDownload } from '@material-ui/icons'

import {
  useQueryPaginator,
  LinkedField,
  OrderField,
  PaginatedTable,
  ShipmentStatusField,
  TrackingNumberField,
  ValueField,
  DateTimeField,
} from 'src/components/Table'
import { ExportDialog } from 'src/components/Dialog'

import { skuit } from 'src/services/skuit'

const NavLink = React.forwardRef((props: NavLinkProps, ref: React.Ref<HTMLAnchorElement>) => (
  <RouterNavLink innerRef={ref} {...props} />
))
NavLink.displayName = 'NavLink'

const CloudDownload = styled(MuiCloudDownload)(spacing)
const Divider = styled(MuiDivider)(spacing)

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing)

export const ShipmentListPage = () => {
  const [exportOpen, setExportOpen] = useState(false)

  const paginator = useQueryPaginator('parcel-shipment-list', skuit.client.parcel.shipments.list)

  return (
    <React.Fragment>
      <Helmet title="Parcel Shipments" />

      <Grid justify="space-between" container spacing={10}>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Parcel Shipments
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} exact to="/">
              Dashboard
            </Link>
            <Typography>Parcel Shipments</Typography>
          </Breadcrumbs>
        </Grid>
      </Grid>

      <Divider my={6} />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Button variant="contained" onClick={() => setExportOpen(true)}>
            <CloudDownload mr={2} /> Export Parcel Shipments to CSV
          </Button>
        </Grid>
        <Grid item xs={12}>
          <PaginatedTable
            title="Parcel Shipments"
            fields={[
              {
                id: 'trackingNumber',
                label: 'Carrier/Tracking Number',
                renderer: LinkedField(TrackingNumberField),
              },
              { id: 'consignee', label: 'Consignee', renderer: ValueField },
              { id: 'facility.name', label: 'Facility', renderer: ValueField },
              { id: 'status', label: 'Status', renderer: ShipmentStatusField },
              { id: 'order', label: 'Order', renderer: OrderField },
              { id: 'shippedOn', label: 'Shipped on', renderer: DateTimeField },
            ]}
            paginator={paginator}
          />
        </Grid>
        <Grid item xs={12}>
          <Button variant="contained" onClick={() => setExportOpen(true)}>
            <CloudDownload mr={2} /> Export Parcel Shipments to CSV
          </Button>
        </Grid>
      </Grid>
      <ExportDialog
        name="Parcel Shipments"
        download={skuit.client.parcel.shipments.export}
        open={exportOpen}
        fields={[
          'shipment_guid',
          'tracking_number',
          'consignee',
          'facility',
          'address1',
          'address2',
          'city',
          'state',
          'postal_code',
          'status',
          'order_guid',
          'order_number',
          'order_details',
          'ordered_on',
          'carrier',
          'shipped_on',
          'faciltiy_guid',
          'facility_name',
          'facility_address1',
          'facility_address2',
          'facility_city',
          'facility_state',
          'facility_postal_code',
        ]}
        handleClose={() => setExportOpen(false)}
      />
    </React.Fragment>
  )
}
